"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_EXTENSION_LABEL = exports.DIRECT_DEBIT_EDIT_LINK_LABEL = exports.AOH_LABEL = exports.SMOOTH_PAY_LABEL = exports.AOH_DUE_DATE_LABEL = exports.DD_DUE_DATE_LABEL = exports.OVERDUE_PAY_NOW_LABEL = exports.POTD_LABEL = exports.DIRECT_DEBIT_LINK_LABEL = exports.DIRECT_DEBIT_SETUP_LABEL = exports.TOTAL_BALANCE_LABEL = exports.DUE_DATE_LABEL = void 0;
exports.DUE_DATE_LABEL = 'Due ';
exports.TOTAL_BALANCE_LABEL = 'Total balance';
exports.DIRECT_DEBIT_SETUP_LABEL = 'Direct Debit is set up';
exports.DIRECT_DEBIT_LINK_LABEL = 'Set up a Direct Debit';
exports.POTD_LABEL = 'Pay on time discount if paid by the due date';
exports.OVERDUE_PAY_NOW_LABEL = 'Overdue - pay now';
exports.DD_DUE_DATE_LABEL = 'Will be deducted on ';
exports.AOH_DUE_DATE_LABEL = 'To be reviewed on ';
exports.SMOOTH_PAY_LABEL = 'SmoothPay instalment';
exports.AOH_LABEL = 'Arrears on hold';
exports.DIRECT_DEBIT_EDIT_LINK_LABEL = 'Edit';
exports.PAYMENT_EXTENSION_LABEL = 'Payment extension applied - new due date indicated above.';
//# sourceMappingURL=AccountBalance.constants.js.map